import request from '@/config/request.js'
const ApiOrder = request.Order
const ApiStudentManagement = request.StudentManagement
const ApiRenewal = request.Renewal

import tools from '@/util/tools'
const basic = tools.basic
import common from '@/components/common/'
export default {
    components: {
      ...common,
    },
  props: [],
  data() {
  
    return {
      row: {},
      // 需要给分页组件传的信息
      paginations: {
        current_page: 1,
        total: 0,
        page_size: 10,
        page_sizes: [10, 20, 30],
        layout: 'total, sizes, prev, pager, next, jumper'
      },
      loading: false,
      visible: false,
      isDetail: false,
      expandedKeys: [],
      tableList: [],
      taskId: '',
      currentRow: null,
      defaultRenewedStudentIds: [],
      defaultRenewedStudentOrderIds: {},
      selectedStudentIds: [],
      selectedOrderIds: [],
      paymentTagList: [
        {
          name: '全款',
          value: 'FULL'
        },
        {
          name: '定金',
          value: 'DEPOSIT'
        },
        {
          name: '尾款',
          value: 'FINAL'
        },
      ],
      
    }
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    getStudentList () {
      this.listLoading = true
      const cur = this.row || this.currentRow || {}
      const sc = cur && cur.studyClass && cur.studyClass.studyClassId
        ? cur.studyClass.studyClassId
        : ''
      const listData = {
        expiryRange: "ALREADY_EXPIRY",
        isLeave: false,
        studentCondition: "NORMAL",
        studyClassId: sc
      }
      const _query = {
        offset: (this.paginations.current_page - 1) * this.paginations.page_size,
        limit: this.paginations.page_size,
        data: listData,
        filters: null,
        orFilters: null,
        order: 'desc',
        sort: 'studentId'
      }
      ApiStudentManagement.getStudentList.call(this, _query, (listData) => {
        const ids = Array.isArray(this.defaultRenewedStudentIds)
          ? this.defaultRenewedStudentIds
          : []
        const list = Array.isArray(listData.content)
          ? listData.content
          : []
        this.tableList = list.map(i => {
          const sid = i && i.studentId
          const renewBase = ids.indexOf(sid) >= 0
          const renewDyn = this.hasNullSelectionForStudent(sid)
          const renew = renewBase || renewDyn
          return { ...i, isRenew: renew }
        })
        this.paginations.total = parseInt(listData.totalElements)
      })
    },
    expandVisible() { return '' },
    init(row) {
      // row.renewedStudentIds: [238467]
      // row.renewedStudentOrderIds: {238467: [16700, 16743]}
      this.row = row
      this.visible = true
      this.taskId = row && row.id ? row.id : ''
      this.currentRow = row || this.currentRow
      let ids = []
      if (row && Array.isArray(row.renewedStudentIds)) {
        ids = row.renewedStudentIds.slice()
      }
      // console.log(ids, 'ids')
      this.defaultRenewedStudentIds = ids
      let map = {}
      if (row && row.renewedStudentOrderIds && typeof row.renewedStudentOrderIds === 'object') {
        map = { ...row.renewedStudentOrderIds }
      }
      this.defaultRenewedStudentOrderIds = map
      this.buildInitialSelection(row)
      this.getStudentList()

    },
    getStatusString (data, value) {
      for (let j = 0; j < this[data].length; j++) {
        if (this[data][j].value === value) {
          return this[data][j].name
        }
      }
    },
    getRowKey(row) {
      if (!row.id) row.id = Math.random().toString(36).slice(2)
      return row.id
    },
    toggleChildren(row) {
      if (!row) return
      const key = this.getRowKey(row)
      const idx = this.expandedKeys.indexOf(key)
      if (idx >= 0) {
        this.expandedKeys.splice(idx, 1)
        return
      }
      this.expandedKeys.push(key)
      if (!Array.isArray(row.children)) {
        this.$set(row, 'children', [])
        const param = {
          offset: 0,
          limit: 1000,
          data: null,
          filters: [
            { field: 'zoneStudent.studentId', operator: 'eq', value: row.studentId }
          ],
          orFilters: null,
          order: 'desc',
          sort: 'createTime'
        }
        ApiOrder.getStudentOrder.call(this, param, (res => {
          const list = Array.isArray(res.content) ? res.content : []
          const set = this.getSelectedOrderIdSet(row.studentId)
          row.children = list.map(i => {
            const oid = i && (i.orderId != null ? i.orderId : i.id)
            const checked = set.has(String(oid))
            return { ...i, checked }
          })
          this.$nextTick(() => { if (this.$refs.renewTable) this.$refs.renewTable.doLayout() })
        }), false, err => {
          this.$message({ message: err.message || '获取订单失败', type: 'error' })
        })
      }
      this.$nextTick(() => { if (this.$refs.renewTable) this.$refs.renewTable.doLayout() })
      
    },
    getOrderNum (row) {
      console.log(row)
      const orders = this.defaultRenewedStudentOrderIds[row.studentId] || []
      return orders.length > 0 ? `（${orders.length}）` : ''
    },
    onOrderCheck(studentRow, orderRow) {
      if (!orderRow) return
      const sid = studentRow && studentRow.studentId
      const oid = orderRow && (orderRow.orderId != null ? orderRow.orderId : orderRow.id)
      if (orderRow.checked) {
        this.addSelection(sid, oid)
        this.removeNullSelectionForStudent(sid)
      } else {
        this.removeSelection(sid, oid)
        const hasOrders = this.hasOrderSelectionForStudent(sid)
        if (!hasOrders && studentRow.isRenew) {
          this.addSelection(sid, null)
        }
      }
    },
    onStudentRenewChange(row) {
      const sid = row && row.studentId
      if (row.isRenew) {
        const hasOrders = this.hasOrderSelectionForStudent(sid)
        const hasNull = this.hasNullSelectionForStudent(sid)
        if (!hasOrders && !hasNull) this.addSelection(sid, null)
      } else {
        this.removeNullSelectionForStudent(sid)
      }
    },
    buildInitialSelection(row) {
      this.selectedStudentIds = []
      this.selectedOrderIds = []
      const ids = Array.isArray(row && row.renewedStudentIds)
        ? row.renewedStudentIds
        : []
      const map = row && row.renewedStudentOrderIds && typeof row.renewedStudentOrderIds === 'object'
        ? row.renewedStudentOrderIds
        : {}
      ids.forEach(sid => {
        const arr = Array.isArray(map[sid]) ? map[sid] : []
        if (arr.length === 0) {
          this.addSelection(sid, null)
        } else {
          arr.forEach(oid => this.addSelection(sid, oid))
        }
      })
    },
    addSelection(sid, oid) {
      const s = String(sid)
      const o = oid == null ? null : String(oid)
      const idx = this.selectedStudentIds.findIndex((v, i) => {
        const vv = String(v)
        const oo = this.selectedOrderIds[i]
        const oostr = oo == null ? null : String(oo)
        return vv === s && oostr === o
      })
      if (idx >= 0) return
      this.selectedStudentIds.push(sid)
      this.selectedOrderIds.push(oid == null ? null : oid)
    },
    removeSelection(sid, oid) {
      const s = String(sid)
      const o = oid == null ? null : String(oid)
      const idx = this.selectedStudentIds.findIndex((v, i) => {
        const vv = String(v)
        const oo = this.selectedOrderIds[i]
        const oostr = oo == null ? null : String(oo)
        return vv === s && oostr === o
      })
      if (idx < 0) return
      this.selectedStudentIds.splice(idx, 1)
      this.selectedOrderIds.splice(idx, 1)
    },
    hasOrderSelectionForStudent(sid) {
      const s = String(sid)
      for (let i = 0; i < this.selectedStudentIds.length; i++) {
        const vv = String(this.selectedStudentIds[i])
        const oo = this.selectedOrderIds[i]
        if (vv === s && oo != null) return true
      }
      return false
    },
    hasNullSelectionForStudent(sid) {
      const s = String(sid)
      for (let i = 0; i < this.selectedStudentIds.length; i++) {
        const vv = String(this.selectedStudentIds[i])
        const oo = this.selectedOrderIds[i]
        if (vv === s && oo == null) return true
      }
      return false
    },
    removeNullSelectionForStudent(sid) {
      const s = String(sid)
      for (let i = this.selectedStudentIds.length - 1; i >= 0; i--) {
        const vv = String(this.selectedStudentIds[i])
        const oo = this.selectedOrderIds[i]
        if (vv === s && oo == null) {
          this.selectedStudentIds.splice(i, 1)
          this.selectedOrderIds.splice(i, 1)
        }
      }
    },
    getSelectedOrderIdSet(sid) {
      const s = String(sid)
      const set = new Set()
      for (let i = 0; i < this.selectedStudentIds.length; i++) {
        const vv = String(this.selectedStudentIds[i])
        const oo = this.selectedOrderIds[i]
        if (vv === s && oo != null) set.add(String(oo))
      }
      return set
    },
  
    dataFormSubmit() {
      const studentIds = this.selectedStudentIds.slice()
      const studentOrderIds = this.selectedOrderIds.slice()
      const payload = {
        zoneRenewalTask: { id: this.taskId },
        studentIds,
        studentOrderIds
      }
      // console.log(payload)
      // return;
      ApiRenewal.studentRenewalBatch.call(this, payload, (res => {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.visible = false
            this.$emit('refresh')
          }), false, err => {
            this.$message({
              message: err.message,
              type: 'error'
            })
          })
      // this.$emit('submit', payload)
      // this.visible = false
    }
  }
}
